import React from "react";

const lazyImport = (path) =>
  React.lazy(() => import(/* @vite-ignore */ `./${path.replace(/\\/g, "/")}`));

export const sutraComponents = {
  level1: {
    chapter1: {
      "1_4_3": lazyImport("Sutra_1_4_3"),
      "1_5_4_5": lazyImport("Sutra_1_5_4_5"),
      "1_5_6": lazyImport("Sutra_1_5_6"),
      "1_5_7": lazyImport("Sutra_1_5_7"),
      "1_5_8": lazyImport("Sutra_1_5_8"),
      "1_5_9": lazyImport("Sutra_1_5_9"),
      "1_17": lazyImport("Sutra_1_17"),
      "1_6_12": lazyImport("Sutra_1_6_12"),
      "1_6_13": lazyImport("Sutra_1_6_13"),
    },
    chapter2: {
      "2_1_3": lazyImport("Sutra_2_1_3"),
      "2_1_5": lazyImport("Sutra_2_1_5"),
      "2_1_6": lazyImport("Sutra_2_1_6"),
      "2_1_6a": lazyImport("Sutra_2_1_6a"),
      "2_1_7": lazyImport("Sutra_2_1_7"),
      "2_1_7a": lazyImport("Sutra_2_1_7a"),
      "2_1_7b": lazyImport("Sutra_2_1_7b"),
      "2_1_8": lazyImport("Sutra_2_1_8"),
      "2_1_8a": lazyImport("Sutra_2_1_8a"),
      "2_1_8b": lazyImport("Sutra_2_1_8b"),
      "2_2_12": lazyImport("Sutra_2_2_12"),
      "2_2_13": lazyImport("Sutra_2_2_13"),
      "2_2_15a": lazyImport("Sutra_2_2_15a"),
      "2_2_15b": lazyImport("Sutra_2_2_15b"),
      "2_3_18a": lazyImport("Sutra_2_3_18a"),
      "2_3_18b": lazyImport("Sutra_2_3_18b"),
      "2_4_22a": lazyImport("Sutra_2_4_22a"),
      "2_4_22b": lazyImport("Sutra_2_4_22b"),
      "2_4_22c": lazyImport("Sutra_2_4_22c"),
      "2_4_22d": lazyImport("Sutra_2_4_22d"),
      "2_4_25a": lazyImport("Sutra_2_4_25a"),
      "2_4_25b": lazyImport("Sutra_2_4_25b"),
      "2_4_25c": lazyImport("Sutra_2_4_25c"),
      "2_4_26a": lazyImport("Sutra_2_4_26a"),
      "2_4_26b": lazyImport("Sutra_2_4_26b"),
      "2_5_29a": lazyImport("Sutra_2_5_29a"),
    },
  },
};
